<app-header></app-header>

<ion-content
  [scrollEvents]="true"
  id="request-credit-confirmation"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === platformService?.platformEnum?.tablet ? 'tablet' : 'mobile' : 'desktop'"
>
  <div class="request-credit-confirmation-header">
    <ion-grid [fixed]="true">
      <!-- Row for Breadcrumbs -->
      <ion-row
        *ngIf="(platformService?.isTouchExperience$ | async) === false"
        class="breadcrumbs-row"
      >
        <ion-col size="12">
          <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        </ion-col>
      </ion-row>
      <!-- Row for Header -->
      <ion-row class="title-row">
        <ion-col size="12">
          <h2 data-cy="request-credit-confirmation-text">
            {{ 'i18n.requestCredit.confirmationTitle' | translate }}
          </h2>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <ion-grid [fixed]="true" class="card-content-grid">
    <ion-card>
      <p data-cy="request-credit-confirmation-message">
        {{'i18n.requestCredit.confirmationMessageP1' | translate }}
        <b>&nbsp;{{ userEmail }}&nbsp;</b>
        {{'i18n.requestCredit.confirmationMessageP2' | translate }}
      </p>

      <!-- Buttons -->
      <div class="btn-container">
        <ion-button
          class="usf-outline-green-dsktp-tblt-modal-button"
          (click)="onClickSubmitAnother()"
          data-cy="click-submit-another-request-button"
        >
          {{ 'i18n.requestCredit.submitAnotherRequest' | translate}}
        </ion-button>
        <ion-button
          class="usf-fill-green-dsktp-tblt-modal-button"
          (click)="onClickReturnHome()"
          data-cy="click-return-home-button"
        >
          {{ 'i18n.requestCredit.return' | translate}}
        </ion-button>
      </div>
    </ion-card>
  </ion-grid>

  <app-footer></app-footer>
</ion-content>
